/* CREAMi Rescue Guide — form submit, success-state swap, Klaviyo subscribe. */
(function () {
  if (window.__crgInit) return;
  window.__crgInit = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Smooth-scroll any [data-crg-scroll] link to its #hash target.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-crg-scroll]');
    if (!link) return;
    var id = link.getAttribute('href');
    if (!id || id.charAt(0) !== '#') return;
    var target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.querySelectorAll('[data-crg-form-wrap]').forEach(function (wrap) {
    // The Liquid {% form %} tag can't take a hyphenated data-* attribute, so
    // match the rendered <form> directly.
    var form = wrap.querySelector('#crg-lead-form') || wrap.querySelector('form');
    var success = wrap.querySelector('[data-crg-success]');
    var errorEl = wrap.querySelector('[data-crg-error]');
    var submitBtn = wrap.querySelector('[data-crg-submit]');
    var skipBtn = wrap.querySelector('[data-crg-skip]');
    var requireEmail = wrap.dataset.requireEmail === 'true';
    var pdfUrl = wrap.dataset.pdfUrl || '';
    var klaviyoKey = (wrap.dataset.klaviyoKey || '').trim();
    var klaviyoList = (wrap.dataset.klaviyoList || '').trim();
    var sourceLabel = (wrap.dataset.sourceLabel || 'creami_rescue_guide').trim();

    if (!form || !success) return;

    function showSuccess() {
      form.hidden = true;
      success.hidden = false;
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    // Visual only — deliberately does NOT set button.disabled. Shopify's bot
    // protection intercepts the submit, fetches a CAPTCHA token, then re-submits
    // via the button; disabling it makes that re-submit silently never happen.
    // .is-loading sets pointer-events:none, which stops double-clicks safely.
    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.classList.toggle('is-loading', isLoading);
    }

    // If email isn't required, the download is already visible; the form
    // stays too, in case the visitor wants to opt in anyway.
    if (!requireEmail) {
      showSuccess();
      form.hidden = false;
    }

    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        showSuccess();
      });
    }

    // Shopify redirects back with ?customer_posted=true after a successful
    // customer form submission — that's our signal to reveal the download.
    function wasJustSubmitted() {
      return /[?&]customer_posted=true/.test(window.location.search);
    }

    async function subscribeToKlaviyo(firstName, email) {
      if (!klaviyoKey) return; // credentials not configured yet — no-op

      // Klaviyo "Create Client Subscription" endpoint (public company_id,
      // no server/API key needed). Re-verify field shape + revision date
      // against https://developers.klaviyo.com/en/reference/create_client_subscription
      // once the client provides real credentials, before going live.
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  properties: { signup_source: 'creami_rescue_guide' },
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } },
                  },
                },
              },
            },
          },
          relationships: klaviyoList
            ? { list: { data: { type: 'list', id: klaviyoList } } }
            : undefined,
        },
      };

      var res = await fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoKey),
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            revision: '2026-07-15',
          },
          body: JSON.stringify(body),
          // The native form submit navigates immediately after this fires;
          // keepalive lets the request complete anyway.
          keepalive: true,
        }
      );

      if (!res.ok && res.status !== 202) {
        throw new Error('Klaviyo request failed with status ' + res.status);
      }
    }

    // Returning from a successful native submit — reveal the download straight away.
    if (wasJustSubmitted()) {
      showSuccess();
      var section = document.getElementById('crg-form');
      if (section) {
        section.scrollIntoView({ block: 'start' });
      }
    }

    form.addEventListener('submit', function (e) {
      clearError();

      var firstName = form.querySelector('[name="contact[first_name]"]');
      var email = form.querySelector('[name="contact[email]"]');
      var honeypot = form.querySelector('[name="website"]');

      var firstNameVal = firstName ? firstName.value.trim() : '';
      var emailVal = email ? email.value.trim() : '';
      var isBot = honeypot && honeypot.value.trim() !== '';

      if (!firstNameVal) {
        e.preventDefault();
        showError('Please enter your first name.');
        return;
      }
      if (!EMAIL_RE.test(emailVal)) {
        e.preventDefault();
        showError('Please enter a valid email address.');
        return;
      }

      if (isBot) {
        // Quietly succeed without creating a customer — don't tip off bots,
        // don't block a real visitor who tripped it.
        e.preventDefault();
        showSuccess();
        return;
      }

      // Valid: do NOT preventDefault. The native submit must proceed on the real
      // click gesture so Shopify's bot protection attaches its CAPTCHA token —
      // a programmatic or AJAX submit is rejected with 400 "CAPTCHA token".
      //
      // Deferred: disabling the submit button synchronously inside the submit
      // handler cancels the native submission in Chrome. Let the submit start,
      // then show the loading state.
      setTimeout(function () { setLoading(true); }, 0);

      // keepalive lets this outlive the navigation that's about to happen.
      // Swallow any rejection: an unhandled one must never affect the submit.
      try {
        var kp = subscribeToKlaviyo(firstNameVal, emailVal);
        if (kp && typeof kp.catch === 'function') kp.catch(function () {});
      } catch (err) {
        /* never block the submit */
      }
    });

    // Guard: if there's no PDF configured at all, disable the download button.
    var downloadBtn = wrap.querySelector('[data-crg-download]');
    if (downloadBtn && !pdfUrl) {
      downloadBtn.setAttribute('aria-disabled', 'true');
      downloadBtn.addEventListener('click', function (e) {
        e.preventDefault();
      });
    }
  });
})();
